import { useState, useEffect } from 'react';
import { navItems } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <div className="flex items-center gap-2 flex-shrink-0">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }} className="flex items-center gap-2 cursor-pointer">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-white text-sm"></i>
              </div>
              <span className="text-foreground-950 font-heading font-bold text-lg whitespace-nowrap">51吃瓜爆料网</span>
            </a>
          </div>

          <div className="hidden md:flex items-center gap-1">
            {navItems.slice(0, 6).map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer text-foreground-600 hover:text-primary-500 transition-colors" aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              投稿爆料
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-2 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="mt-2 mx-4 inline-flex items-center justify-center gap-1.5 bg-primary-500 text-white px-5 py-2.5 rounded-full text-sm font-semibold cursor-pointer"
            >
              投稿爆料
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}